export default "__VITE_ASSET__92380813__"